import { createContext, FC, ReactNode, useContext } from "react";

import type { AssistantPaymentCard } from "../PaymentCards/helpers/parsePaymentCards";

import type { DonorPaymentControl } from "@/features/DonorDashboard/DonorPaymentDetailDrawer/types";

export interface PaymentDetailsContextValue {
  openPayment: (payment: AssistantPaymentCard, control?: DonorPaymentControl) => void;
}

const PaymentDetailsContext = createContext<PaymentDetailsContextValue | null>(null);

export const PaymentDetailsProvider: FC<{ value: PaymentDetailsContextValue; children: ReactNode }> = ({
  value,
  children,
}) => <PaymentDetailsContext.Provider value={value}>{children}</PaymentDetailsContext.Provider>;

export const usePaymentDetailsContext = () => useContext(PaymentDetailsContext);
